// extracted by mini-css-extract-plugin
export default {"bigButton":"bigButton_bigButton__hXtRF","bigButton_auto":"bigButton_bigButton_auto__Isx5s"};